module.exports = __webpack_public_path__ + "img/Neo.578dc19a.jpg";